import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-industrial-ox',
  templateUrl: './industrial-ox.component.html',
  styleUrls: ['./industrial-ox.component.css']
})
export class IndustrialOxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
